import React from "react";
import { withTranslation } from "react-i18next";
import { FormGroup, ControlLabel, Radio } from "react-bootstrap";

class MessagePurpose extends React.Component {
  handleRadioChange(e) {
    const { handleChange } = this.props;
    handleChange(e.target.value);
  }

  handleRadioChange = this.handleRadioChange.bind(this);

  render() {
    const selected = this.props.value;

    this.options = [
      {
        type: "owner",
        text: this.props.t('form.fields.purpose.variant.owner')
      },
      {
        type: "admin",
        text: this.props.t('form.fields.purpose.variant.admin')
      },
      {
        type: "tech",
        text: this.props.t('form.fields.purpose.variant.tech')
      }
    ];

    const radios = this.options.map(option => (
      <Radio
        key={option.type}
        name="purpose"
        value={option.type}
        defaultChecked={selected === option.type}
      >
        {option.text}
      </Radio>
    ));

    return (
      <FormGroup onChange={this.handleRadioChange}>
        <ControlLabel>{this.props.t('form.fields.purpose.label')}</ControlLabel>
        {radios}
      </FormGroup>
    );
  }
}

export default withTranslation()(MessagePurpose);



// WEBPACK FOOTER //
// ./src/components/MessagePurpose.js